module.exports = __webpack_public_path__ + "img/register_top.d00c35bc.svg";